import { Yup } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import * as ValidationRegex from 'src/common/NBCIValidationRegex.js'
import NBCICanadaInvoiceKeys from 'src/constants/locale/key/NBCICanadaInvoice'

function makeValidationSchema(translate) {
  const regexAlphaNumeric =
    ValidationRegex.regexAlphaNumeric
  let errMsgAlphaNumeric = translate(
    Namespace.N_B_C_I_CANADA_INVOICE,
    NBCICanadaInvoiceKeys.Validations.ERR_MSG_ALPHA_NUMERIC_SPEC_CHAR
  )
  // const errMsgAlphaNumeric =
  //   'Invalid Value - Allowed Alphanumeric, spaces, and /,+-$#@%&!^_:;.?()[]{}\'"'
  const regexDigitWithDecimal42 = ValidationRegex.regex4DigitWith2Decimal
  const errMsgDigitWithDecimal42 =
    'Please enter only numeric values with up to 4 digits and 2 decimal'
  const regexDigitWithDecimal62 = ValidationRegex.regex6DigitWith2Decimal
  const errMsgDigitWithDecimal62 =
    'Please enter only numeric values with up to 6 digits and 2 decimal'
  const regexDigitWithDecimal92 = ValidationRegex.regex9DigitWith2Decimal
  const errMsgDigitWithDecimal92 =
    'Please enter only numeric values with up to 9 digits and 2 decimal'

  const validateStringField = (maxLength, regexPattern, errorMsg) =>
    Yup.string()
      .nullable()
      .matches(regexPattern, errorMsg)
      .max(
        maxLength,
        'Field can contain maximum of ' + maxLength + ' characters'
      )

  return Yup.object({
    containerNo: validateStringField(30, regexAlphaNumeric, errMsgAlphaNumeric),
    freightCharges: Yup.string().nullable(),
    placeOfLadding: validateStringField(
      30,
      regexAlphaNumeric,
      errMsgAlphaNumeric
    ),
    deliveryInstructions: validateStringField(
      50,
      regexAlphaNumeric,
      errMsgAlphaNumeric
    ),
    codAmount: Yup.string()
      .nullable()
      .matches(regexDigitWithDecimal42, errMsgDigitWithDecimal42),
    currency: Yup.string().nullable(),
    declareValueOfShipment: Yup.string()
      .nullable()
      .matches(regexDigitWithDecimal92, errMsgDigitWithDecimal92),
    chargeTo: validateStringField(100, regexAlphaNumeric, errMsgAlphaNumeric),
    releaseValue: Yup.string()
      .nullable()
      .matches(regexDigitWithDecimal62, errMsgDigitWithDecimal62)
  })
}

export default makeValidationSchema
